export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Network Automation",
  list: [
    {
      label: "Automated Configuration Management",
      text: "Automatically apply and manage network device configurations, ensuring consistency and compliance.",
    },
    {
      label: "Real-Time Network Monitoring",
      text: "Continuously monitor network performance and health, enabling proactive issue detection and resolution.",
    },
    {
      label: "Scalability",
      text: "Easily scale network operations to accommodate growth without a proportional increase in manual efforts.",
    },
    {
      label: "Integration Capabilities",
      text: "Seamlessly integrate with existing systems and third-party tools to create a cohesive network management ecosystem.",
    },
    {
      label: "Security Enforcement",
      text: "Consistently apply security policies across the network, reducing vulnerabilities and ensuring compliance.",
    },
  ],
};
